import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, Filter, ShoppingBag } from 'lucide-react';
import { products, categories } from '../data/mock';
import BuyModal from '../components/BuyModal';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(p => p.category.toLowerCase().includes(selectedCategory));

  return (
    <div className="section-padding" style={{ backgroundColor: '#fffef2', minHeight: '80vh' }}>
      <div className="container">
        <div style={{ marginBottom: '64px' }}>
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Our Products
          </h1>
          <p className="body-large" style={{ color: '#666666' }}>
            Browse our complete collection of premium bathroom accessories
          </p>
        </div>

        {/* Category Filter */}
        <div style={{ 
          display: 'flex', 
          gap: '16px', 
          marginBottom: '48px',
          flexWrap: 'wrap',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Filter size={20} color="#666666" />
            <span className="body-regular" style={{ color: '#666666' }}>Filter:</span>
          </div>
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.slug)}
              className="btn-secondary"
              style={{
                padding: '8px 16px',
                backgroundColor: selectedCategory === category.slug ? '#333333' : 'transparent',
                color: selectedCategory === category.slug ? '#fffef2' : '#333333',
                border: `1px solid ${selectedCategory === category.slug ? '#333333' : '#bcbbb4'}`,
                borderRadius: '0px'
              }}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid-product-showcase">
          {filteredProducts.map(product => (
            <div 
              key={product.id}
              className="product-card hover-lift"
            >
              <Link to={`/product/${product.id}`}>
                <img 
                  src={product.image}
                  alt={product.name}
                  className="product-card-image"
                  style={{ backgroundColor: '#fff' }}
                />
              </Link>
              <div style={{ padding: '16px' }}>
                <Link to={`/product/${product.id}`}>
                  <h3 className="product-card-title">
                    {product.name}
                  </h3>
                </Link>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  marginBottom: '8px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Star size={14} fill="#333333" color="#333333" />
                    <span className="body-small">{product.rating}</span>
                  </div>
                  <span className="body-small" style={{ color: '#bcbbb4' }}>
                    ({product.reviews} reviews)
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '12px' }}>
                  <span className="heading-3">₹{product.price.toLocaleString()}</span>
                  <span className="body-small" style={{ 
                    color: '#bcbbb4', 
                    textDecoration: 'line-through' 
                  }}>
                    ₹{product.originalPrice.toLocaleString()}
                  </span>
                  <span className="body-small" style={{ color: '#ba3e2b' }}>
                    {product.discount}% off
                  </span>
                </div>
                <div style={{
                  display: 'inline-block',
                  padding: '4px 8px',
                  backgroundColor: product.inStock ? '#ebeade' : '#f6f5e8',
                  borderRadius: '0px',
                  marginBottom: '12px'
                }}>
                  <span className="body-small" style={{ 
                    color: product.inStock ? '#333333' : '#666666' 
                  }}>
                    {product.inStock ? 'In Stock' : 'Out of Stock'}
                  </span>
                </div>
                <button
                  onClick={() => setSelectedProduct(product)}
                  className="btn-primary"
                  style={{
                    width: '100%',
                    minWidth: 'auto',
                    height: '48px',
                    padding: '12px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  <ShoppingBag size={16} />
                  Buy Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div style={{ 
            textAlign: 'center', 
            padding: '80px 0',
            color: '#666666'
          }}>
            <p className="body-large">No products found in this category</p>
          </div>
        )}

        {/* Buy Modal */}
        {selectedProduct && (
          <BuyModal 
            product={selectedProduct} 
            onClose={() => setSelectedProduct(null)} 
          />
        )}
      </div>
    </div>
  );
};

export default Products;
